import {Box, Card, Stack, styled} from '@mui/material';
import {designSystemToken} from '@lightricks/react-design-system';
import {
  IMAGE_HEIGHT,
  IMAGE_WIDTH,
  PROJECT_CARD_HEIGHT,
  PROJECT_CARD_MAX_WIDTH,
  PROJECT_CARD_MIN_WIDTH,
  PROJECT_CONTENT_CARD_HEIGHT,
} from './constants';

export const RootCard = styled(Card)(() => ({
  'borderRadius': '16px',
  'boxShadow': 'none',
  'background': 'transparent',
  'width': '100%',
  'height': `${PROJECT_CARD_HEIGHT}px`,
  'minWidth': `${PROJECT_CARD_MIN_WIDTH}px`,
  'maxWidth': `${PROJECT_CARD_MAX_WIDTH}px`,
  'display': 'flex',
  'gap': '12px',
  'flexDirection': 'column',
  'overflow': 'visible',
  'position': 'relative',
  '&:hover': {
    '> div:nth-of-type(1)': {
      transition:
        'transform 0.25s cubic-bezier(.4,2,.6,1), box-shadow 0.25s cubic-bezier(.4,2,.6,1)',
      transform: 'scale(1.01)',
    },
  },
}));

export const CardContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  flex: '1 0 0',
  alignSelf: 'stretch',
  maxHeight: `${PROJECT_CONTENT_CARD_HEIGHT}px`,
  background: designSystemToken('semantic.bg.secondary'),
  border: `1px solid ${designSystemToken('semantic.bg.tertiary')}`,
  borderRadius: '16px',
  overflow: 'hidden',
}));

export const HeaderContainer = styled(Box)(() => ({
  display: 'flex',
  flex: '1 0 0',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  padding: '16px 16px 0 16px',
}));

export const AssetContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  overflow: 'visible',
  minHeight: '102px',
  width: 'auto',
}));

export const CardSpacer = styled(Box)(() => ({
  display: 'flex',
  flex: '1 0 0',
  alignSelf: 'stretch',
}));

export const ProgressContainer = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  flex: '1 0 0',
  alignSelf: 'stretch',
  borderRadius: '0px 0px 16px 0px',
  width: '100%',
}));

export const ProgressInfo = styled(Box)(() => ({
  display: 'flex',
  padding: '0px 16px 10px 16px',
  justifyContent: 'space-between',
  alignItems: 'center',
  flex: '1 0 0',
  alignSelf: 'stretch',
  gap: '12px',
}));

export const ActionsCell = styled(Box)(() => ({
  flex: '1 0 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  cursor: 'pointer',
}));

export const FooterContainer = styled(Box)(() => ({
  display: 'flex',
  padding: '0px 16px 0px 16px',
  alignItems: 'center',
  gap: '8px',
  alignSelf: 'stretch',
}));

export const FeatureIconContainer = styled(Box)(
  ({background}: {background: string}) => ({
    background,
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '3.333px',
    borderRadius: '8px',
  })
);

export const UserInputsRow = styled(Box)(() => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  gap: '4px',
  overflow: 'hidden',
  paddingInlineEnd: '4px',
  height: '32px',
}));

export const UserInputPill = styled(Box)(
  ({background}: {background: string}) => ({
    padding: '4px',
    borderRadius: '8px',
    background,
    fontFamily: 'Brown LL',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '18px',
    letterSpacing: '0.16px',
  })
);

export const StackedBox = styled(Box)<{rotation: string; opacity?: number}>(
  ({rotation, opacity = 0.4}) => ({
    position: 'absolute',
    top: '4px',
    left: 0,
    display: 'flex',
    width: `${IMAGE_WIDTH}px`,
    height: `${IMAGE_HEIGHT}px`,
    transform: `rotate(${rotation})`,
    transformOrigin: 'bottom right',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    borderRadius: '6.528px',
    background: designSystemToken('semantic.fg.disabled'),
    opacity,
  })
);

export const Boxes = styled(Box)(() => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
}));
